import React from "react";
import _ from "lodash";

import FirstLookPriceSectionPopover from "components/ops-mgmt/account/custom-first-look/FirstLookPriceSectionPopover";
import PriceSectionView from "components/common/PriceSectionView";
import { PRICE_TYPE, PRICE_TYPE_BY_NAME } from "constants/PriceType";

function FirstLookPriceSection({
  item,
  networkId,
  onOpen,
  onClose,
  currency = "USD",
  place,
}) {
  const setEverySetting = _.find(
    item.priceSettings,
    (st) => st.isSetForEverything
  );

  const parsedCurrency =
    setEverySetting && !_.isEmpty(setEverySetting.currency)
      ? setEverySetting.currency
      : currency;

  const brandedSettings = _.filter(item.priceSettings, {
    isSetForEverything: false,
  });

  return (
    <div>
      <div className="-mx-2 px-2">
        <div
          className={
            item.priceSettings && !_.isEmpty(item.priceSettings)
              ? "flex items-center justify-end gap-1"
              : ""
          }
        >
          {setEverySetting ? (
            <>
              <PriceSectionView
                item={setEverySetting}
                currency={parsedCurrency}
                branded={setEverySetting.branded}
              ></PriceSectionView>
            </>
          ) : (
            <>
              <div className="text-xs font-medium leading-none text-gray-600">
                {PRICE_TYPE[PRICE_TYPE_BY_NAME.BRAND_SETTING]}
              </div>
            </>
          )}
        </div>
      </div>
      {brandedSettings.length > 0 && (
        <div className="border-t">
          <FirstLookPriceSectionPopover
            networkId={networkId}
            currency={parsedCurrency}
            settings={brandedSettings}
            place={place}
            onOpen={onOpen}
            onClose={onClose}
            triggerElement={
              <div className="cursor-pointer hover:underline">
                <BrandedPriceView settings={brandedSettings}></BrandedPriceView>
              </div>
            }
          ></FirstLookPriceSectionPopover>
        </div>
      )}
    </div>
  );
}

function BrandedPriceView({ settings }) {
  return (
    <div>
      <span className="rounded bg-green-200 px-2 text-xs text-green-900">
        Branded ({settings.length})
      </span>
    </div>
  );
}

export default FirstLookPriceSection;
